import { create } from 'zustand';

interface ConfigState {
  hasLoginSubjectSelector: boolean;
  hasAudienceScopeVisibleSelect: boolean;
  platformName?: string;
  isUniversity?: boolean;
}

const useConfigStore = create<ConfigState>()(() => ({
  hasLoginSubjectSelector: true,
  hasAudienceScopeVisibleSelect: false,
}));

export default useConfigStore;
